module.exports = __webpack_public_path__ + "img/senias-datensaetze-seite.49e701f3.png";